import React from 'react';
import {Review} from "../../services/api/ReviewService";
import Avatar from "../Avatar";
import {Badge} from "react-bootstrap";
import StarIcon from "../../icons/StarIcon";
import {IconSize} from "../../services/IconConstants";
import CalendarIcon from "../../icons/CalendarIcon";

interface Props {
    review: Review
}

const CaddieReview = ({review}: Props) => {
    return (
        <div className={"liveReviewFeed-review-container"}>
            {review.caddieUser && <div className={"liveReviewFeed-header-container"}>
                <div className={"liveReviewFeed-header-caddie-container"}>
                    <Avatar size={'xsm'} user={review.caddieUser.id} />
                    <div className={"liveReviewFeed-header-caddie-name"}>
                        <span>{review.caddieUser.displayName}</span>
                        <div>
                            {[...Array(5)].map((_, idx) => {
                                return <StarIcon
                                    key={idx}
                                    size={IconSize.sm}
                                    active={review.rating > 0 && review.rating >= (idx + 1)}
                                />
                            })}
                        </div>
                    </div>
                </div>

                <div>
                    <CalendarIcon size={IconSize.sm} />
                    <span className={"liveReviewFeed-header-created-txt"}>{review.created}</span>
                </div>
            </div>}

            <div className={"liveReviewFeed-body"}>
                {review.message && <p>{review.message}</p>}
                {!review.message && <p><i>No comment left.</i></p>}
                {review.attributes.map((attribute) => (
                    <Badge>{attribute}</Badge>
                ))}
            </div>

            <div className={"liveReviewFeed-footer"}>
                {review && review.author && <div>
                    <span><i>Review left by:</i> {review.author.displayName}</span>
                </div>}
            </div>
        </div>
    )
}

export default CaddieReview;